export default function accordion() {
    let accordions = document.querySelectorAll('.questions__item')
    accordions.forEach(accordion=>{
        accordion.addEventListener('click', ()=>{
            if(accordion.classList.contains('questions__item--active')) {
                accordion.classList.remove('questions__item--active')
                accordion.querySelectorAll('.questions__text').forEach(text=>{
                    text.style.maxHeight = ''
                })
            } else {
                accordion.classList.add('questions__item--active')
                accordion.querySelectorAll('.questions__text').forEach(text=>{
                    text.style.maxHeight = text.scrollHeight + 'px'
                })
            }
        })
    })
    let sort = document.querySelector('.catalog__sort'),
        items = sort?.querySelector('.catalog__sort-items');
    sort?.addEventListener('click', ()=>{
        sort.classList.toggle('catalog__sort--active')
        items.style.maxHeight = items.scrollHeight + 'px'
        if(!sort.classList.contains('catalog__sort--active'))
            items.style.maxHeight = ''
    })
    if(sort) {
        window.addEventListener('click', (e)=>{
            if(!e.composedPath().includes(sort)) {
                sort.classList.remove('catalog__sort--active')
                items.style.maxHeight = ''
            }
        })
    }
}